module.exports = __webpack_public_path__ + "img/21.d6b1ec3f.webp";